import { onBeforeUnmount, toValue, watchEffect, type MaybeRefOrGetter } from 'vue';

/**
 * Shared map of route path -> human label for the last breadcrumb segment.
 * Detail pages register a label (e.g. an order number) so the breadcrumb
 * shows it instead of the raw Mongo ObjectId from the URL.
 */
export function useBreadcrumbLabels() {
  return useState<Record<string, string>>('breadcrumb-labels', () => ({}));
}

/**
 * Register a breadcrumb label for the current route path. Pass a ref or getter;
 * the label updates when it changes and is removed when the page unmounts.
 */
export function useBreadcrumbLabel(label: MaybeRefOrGetter<string | null | undefined>) {
  const route = useRoute();
  const labels = useBreadcrumbLabels();
  const path = route.path;

  watchEffect(() => {
    const value = toValue(label);
    if (value) {
      labels.value = { ...labels.value, [path]: value };
    }
  });

  onBeforeUnmount(() => {
    if (path in labels.value) {
      const next = { ...labels.value };
      delete next[path];
      labels.value = next;
    }
  });
}
